
import AppRouter from "./AppRouter";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { get_Token, onMessageListener } from "./API/Firebase";
import { firebasePush, saveDeviceToken } from "./Features/AuthSlice";
import { allAds } from "./Features/AdApi/AdSlice";
import { allProducts, siteInfo } from "./Features/HomeApi/HomeSlice";

function App() {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const token = useSelector((state) => state.auth?.currentUser?.token);

  const [notification, setNotification] = useState({
    title: "",
    body: "",
  });

  // ✅ Enable Notifications (User Click Required)
  const enableNotifications = async () => {
    if (!isLoggedIn) return;

    const currentToken = await get_Token();

    if (currentToken) {
      dispatch(saveDeviceToken(currentToken));
      dispatch(
        firebasePush({
          token,
          device_id: currentToken,
          device_type: "web",
        })
      );
    }
  };

 
  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        setNotification({
          title: payload.notification?.title,
          body: payload.notification?.body,
        });
      })
      .catch((err) => console.log(err));
  }, []);


  useEffect(() => {
    if (isLoggedIn && notification.title && notification.body) {
      toast.success(
        <div>
          <p>{notification.title}</p>
          <p>{notification.body}</p>
        </div>,
        { autoClose: 5000 }
      );

      setNotification({ title: "", body: "" });
    }
  }, [notification, isLoggedIn]);


  useEffect(() => {
    dispatch(allAds());
    dispatch(allProducts());
    dispatch(siteInfo());
  }, [dispatch]);

  return ( 
    <>
      <ToastContainer autoClose={5000} />

      
      {isLoggedIn && (
        <button
          onClick={enableNotifications}
          style={{ position: "fixed", bottom: 20, right: 20 }}
        >
          Enable Notifications
        </button>
      )}

      <AppRouter />
    </>
  );
}

export default App;
